import { interpret } from '~/node_modules/xstate-v4'
import { FaqRepositoryFetch } from './FaqRepositoryFetch'
import { returnFaqMachine } from './machine'

export function getFaqMachine(langCode: string) {
  return interpret(
    returnFaqMachine().withConfig({
      services: {
        fetchAll: () => new FaqRepositoryFetch().getAll(langCode),
        fetchStandalone: (_, { slug }: any) =>
          new FaqRepositoryFetch().getStandaloneBySlug(langCode, slug),
      },
    }),
  )
}
